/* DEALER TEMPLATES - FO */
export const FETCH_TEMPLATES_FO_BY_DEALER_REQUEST = 'FETCH_TEMPLATES_FO_BY_DEALER_REQUEST';
export const FETCH_TEMPLATES_FO_BY_DEALER_SUCCESS = 'FETCH_TEMPLATES_FO_BY_DEALER_SUCCESS';
export const FETCH_TEMPLATES_FO_BY_DEALER_FAILURE = 'FETCH_TEMPLATES_FO_BY_DEALER_FAILURE';

/* GROUP CUSTOM TEMPLATE */
export const FETCH_GROUP_CUSTOM_TEMPLATE_REQUEST = 'FETCH_GROUP_CUSTOM_TEMPLATE_REQUEST';
export const FETCH_GROUP_CUSTOM_TEMPLATE_SUCCESS = 'FETCH_GROUP_CUSTOM_TEMPLATE_SUCCESS';
export const FETCH_GROUP_CUSTOM_TEMPLATE_FAILURE = 'FETCH_GROUP_CUSTOM_TEMPLATE_FAILURE';

export const DELETE_TEMPLATE = 'TEMPLATES/DELETE_REQUEST';
export const DELETE_TEMPLATE_SUCCESS = 'TEMPLATES/DELETE_SUCCESS';
export const DELETE_TEMPLATE_FAILURE = 'TEMPLATES/DELETE_FAILURE';

/* TEMPLATE LINK */
export const REDIRECT_TO_CUSTOM_TEMPLATE_LINK_REQUEST = 'REDIRECT_TO_CUSTOM_TEMPLATE_LINK_REQUEST';
export const REDIRECT_TO_CUSTOM_TEMPLATE_LINK_SUCCESS = 'REDIRECT_TO_CUSTOM_TEMPLATE_LINK_SUCCESS';
export const REDIRECT_TO_CUSTOM_TEMPLATE_LINK_FAILURE = 'REDIRECT_TO_CUSTOM_TEMPLATE_LINK_FAILURE';
